import axios from "axios";

export const BillsService = {
  getBill(patientToken) {
    return axios.get(
      `${process.env.VUE_APP_API}/bills`,
      {
        headers: {
          Authorization: `Token ${patientToken}`,
        },
      },
    );
  },
};
